<template>
  <v-container class="mt-16">
    <v-row align="center" justify="center">
      <!--suppress HtmlDeprecatedAttribute -->
      <v-col align="center">
        <div class="app-title">Assets by</div>
        <img src="/img/carnetix.svg" alt="CarNetiX" style="max-width: 640px" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Home extends Vue {}
</script>
<style lang="scss" scoped>
div.app-title {
  font-size: 3rem;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5rem;
  text-transform: uppercase;
}
</style>
